module.exports = __webpack_public_path__ + "img/icons_18.9cc2f2d1.svg";